var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Close(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5459 17.9541C19.7572 18.1654 19.876 18.4521 19.876 18.7509C19.876 19.0498 19.7572 19.3365 19.5459 19.5478C19.3346 19.7592 19.0479 19.8779 18.749 19.8779C18.4501 19.8779 18.1635 19.7592 17.9521 19.5478L12 13.5938L6.0459 19.5459C5.83455 19.7573 5.54791 19.876 5.24902 19.876C4.95014 19.876 4.66349 19.7573 4.45215 19.5459C4.2408 19.3346 4.12207 19.048 4.12207 18.7491C4.12207 18.4502 4.2408 18.1635 4.45215 17.9522L10.4062 12L4.45402 6.04595C4.24268 5.8346 4.12395 5.54796 4.12395 5.24907C4.12395 4.95019 4.24268 4.66354 4.45402 4.4522C4.66537 4.24085 4.95201 4.12212 5.2509 4.12212C5.54978 4.12212 5.83643 4.24085 6.04777 4.4522L12 10.4063L17.954 4.45126C18.1654 4.23992 18.452 4.12119 18.7509 4.12119C19.0498 4.12119 19.3364 4.23992 19.5478 4.45126C19.7591 4.66261 19.8778 4.94925 19.8778 5.24814C19.8778 5.54702 19.7591 5.83367 19.5478 6.04501L13.5937 12L19.5459 17.9541Z",
    fill: "#6B7380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Close);
export default __webpack_public_path__ + "static/media/24_close.12e0b393cb06748160dc105f6ba29562.svg";
export { ForwardRef as ReactComponent };